import { SET_FOOTER, SET_PAGE } from './constants';

export default {
  namespaced: true,
  state() {
    return {
      page: '',
      showFooter: false
    };
  },
  mutations: {
    [SET_FOOTER](state, v) {
      return (state.showFooter = v);
    },
    [SET_PAGE](state, v) {
      return (state.page = v);
    }
  }
};
